"use client";

import { useEffect } from "react";

export default function ResizeReLoader() {
  useEffect(() => {
    const getBreakpoint = (width: number): "mobile" | "ipad" | "desktop" => {
      if (width <= 800) return "mobile";
      if (width <= 1024) return "ipad";
      return "desktop";
    };

    let resizeTimer: NodeJS.Timeout;
    let previousBreakpoint = getBreakpoint(window.innerWidth);

    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const currentBreakpoint = getBreakpoint(window.innerWidth);
        if (currentBreakpoint !== previousBreakpoint) {
          window.location.reload();
        }
        previousBreakpoint = currentBreakpoint;
      }, 500);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return null;
}
